import React from 'react';
import { Button, Space } from 'antd';
import { BannerButton } from '../../../../models';

type Props = {
    buttons: BannerButton[];
    onButtonClick: (button: BannerButton) => void;
    size?: 'small' | 'middle' | 'large';
    style?: React.CSSProperties;
    className?: string;
}

const BannerButtons: React.FC<Props> = ({ buttons, onButtonClick, size = 'small', style, className }) => {
    const sortedButtons = [...buttons].sort((a, b) => (a.order || 0) - (b.order || 0));

    return (
        <Space className={className} size={size} style={style}>
            {sortedButtons.map((button) => (
                <Button
                    key={button.id}
                    type="primary"
                    onClick={() => onButtonClick(button)}
                >
                    {button.text}
                </Button>
            ))}
        </Space>
    );
};

export default BannerButtons;
